import React from 'react';
import AGGridDataStore from './store';

const AGGridDataContext = React.createContext<AGGridDataStore>(AGGridDataStore.empty());

export default AGGridDataContext;